import React from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useTranslation} from "react-i18next";
import {Button} from "@material-ui/core";
import User from './user.png'
import Typography from "@material-ui/core/Typography";
import Review from "../../Review";
import useTheme from "@material-ui/core/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Box from "@material-ui/core/Box";
import LocationOnIcon from '@material-ui/icons/LocationOn';
import Slider from "react-slick";
import {styled} from '@material-ui/core/styles';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const useStyles = makeStyles((theme) => ({
    root: {
        flex: 1,
        paddingBottom: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflow: 'hidden'
    },
    image: {
        height: '250px',
        borderRadius: '50%'
    },
}));

const StyledImage = styled(Box)((props) => ({
    backgroundImage: `url(${props.src})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '250px',
    width: '100%',
    maxWidth: '500px',
}))


const SupplierPage = ({handleNext, supplierPersonalDetails}) => {
    const classes = useStyles()
    const {t} = useTranslation();
    const {fullName, description, reviews = [], address, images = []} = supplierPersonalDetails || {}
    const theme = useTheme()
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))
    const addressTitle = typeof address === 'string' ? address : address?.title;
    return <div className={classes.root} style={{width: isDesktop ? theme.maxContentWidth : '100%'}}>
        <Box flex={1} display={'flex'} flexDirection={'column'} width={'100%'} alignItems={'center'} overflow={'auto'}>
            <Box height={'280px'} width={'100%'} overflow={'hidden'}>
                {images.length ? <Slider dots={true}>
                    {images.map(({url, name}) => <div key={url}><Box display={'flex'} justifyContent={'center'}
                                                                     alignItems={'center'}><StyledImage key={name}
                                                                                                        src={url}/></Box>
                    </div>)}
                </Slider> : <Box display={'flex'} alignItems={'center'} justifyContent={'center'} height={'100%'}><img
                    className={classes.image} src={User} alt={'avatar'}/></Box>}
            </Box>
            <Typography variant={'h1'} gutterBottom>{fullName}</Typography>
            {address && <Box bgcolor={theme.palette.primary.main} color={'white'} py={0.5} px={1} borderRadius={'15px'}
                             display={'flex'} alignItems={'center'}>
                <LocationOnIcon fontSize={'inherit'} htmlColor={theme.palette.background.main}/>
                <Typography variant={'body'}>{addressTitle}</Typography>
            </Box>}
            <Box p={2} flex={1} maxWidth={'500px'}>
                <Typography variant={'body1'} gutterBottom align={'center'}>{description}</Typography>
            </Box>
            <Box flex={1} width={'100%'}>
                {reviews.length ? reviews.map(({rating, text, date, name, activity}, index) => {
                    return <Review readOnly={true} rating={rating} text={text} name={name} key={index}
                                   date={date} activity={activity}/>
                }) : <Box display={'flex'} justifyContent={'center'}>
                    {t('no_reviews')}
                </Box>}

            </Box>
        </Box>
        <Box pt={2}>
            <Button onClick={handleNext} color="primary" variant="contained" className={classes.nextButton}>
                {t('book_appointment')}
            </Button>
        </Box>
    </div>
}

export default SupplierPage;